var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAvaliableTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 184,
    viewBox: "0 0 548 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121.771,
    y: 1,
    width: 304.457,
    height: 182,
    rx: 7,
    fill: "url(#paint0_linear_434_464)",
    stroke: "#BB9370",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.6231C0 26.2048 3.58172 22.623 8 22.623H88.617C93.0352 22.623 96.617 26.2048 96.617 30.623V153.377C96.617 157.795 93.0352 161.377 88.617 161.377H8C3.58172 161.377 0 157.795 0 153.377V30.6231Z",
    fill: "url(#paint1_linear_434_464)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451.383 30.6231C451.383 26.2048 454.965 22.623 459.383 22.623H540C544.419 22.623 548 26.2048 548 30.623V153.377C548 157.795 544.419 161.377 540 161.377H459.383C454.965 161.377 451.383 157.795 451.383 153.377V30.6231Z",
    fill: "url(#paint2_linear_434_464)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210.436,
    y: 24.1299,
    width: 1,
    height: 135.74,
    stroke: "#434343"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 275.436,
    y: 24.1299,
    width: 1,
    height: 135.74,
    stroke: "#434343"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 340.436,
    y: 24.1299,
    width: 1,
    height: 135.74,
    stroke: "#434343"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 146.436,
    y: 24.1309,
    width: 256.639,
    height: 135.738,
    rx: 4,
    stroke: "#434343",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 146.436,
    y: 92.7539,
    width: 1,
    height: 256.639,
    transform: "rotate(-90 146.436 92.7539)",
    stroke: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.773 58.3081C199.773 69.6929 190.535 78.9229 179.138 78.9229C167.741 78.9229 158.503 69.6929 158.503 58.3081C158.503 46.9233 167.741 37.6934 179.138 37.6934C190.535 37.6934 199.773 46.9233 199.773 58.3081Z",
    fill: "#E7D5B9",
    stroke: "#E7D5B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.773 126.177C199.773 137.562 190.535 146.792 179.138 146.792C167.741 146.792 158.503 137.562 158.503 126.177C158.503 114.792 167.741 105.562 179.138 105.562C190.535 105.562 199.773 114.792 199.773 126.177Z",
    stroke: "#BB9370"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M329.091 58.3081C329.091 69.6929 319.853 78.9229 308.456 78.9229C297.059 78.9229 287.821 69.6929 287.821 58.3081C287.821 46.9233 297.059 37.6934 308.456 37.6934C319.853 37.6934 329.091 46.9233 329.091 58.3081Z",
    stroke: "#BB9370"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264.686 126.177C264.686 137.562 255.448 146.792 244.051 146.792C232.654 146.792 223.416 137.562 223.416 126.177C223.416 114.792 232.654 105.562 244.051 105.562C255.448 105.562 264.686 114.792 264.686 126.177Z",
    fill: "#E7D5B9",
    stroke: "#E7D5B9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_464",
    x1: 273.999,
    y1: 0,
    x2: 273.999,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2A2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_434_464",
    x1: 0,
    y1: 92.0001,
    x2: 96.617,
    y2: 92.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2A2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2A2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_434_464",
    x1: 548,
    y1: 92.0001,
    x2: 451.383,
    y2: 92.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2A2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2A2B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvaliableTable);
export default __webpack_public_path__ + "static/media/no_avaliable_table.a2671defe8b7d60c58c9e0c450ebdd6f.svg";
export { ForwardRef as ReactComponent };